import { useCallback } from 'react';

import { feedChatsStore } from './feed-chats.store';

export const useFeedComposer = () =>
  useCallback((threadId: string) => feedChatsStore.add(threadId), []);
